import * as layerOps from '../api/Layers/layer-operations';
import { LAYER_SUBTYPES } from '../api/Layers/Layers';

const WMS_DEFAULT_FIELD = 'wms:';

/**
 * Creates the URL where the utfGrid data can be fetched for a later check.
 *
 * @param {object} arg - The arguments object.
 * @param {object} arg.layer - The layer object.
 * @param {Array} arg.bbox - The WMS layer Bounding Box.
 * @returns {string} The URL of the UTF Grid or an empty string if it doesn't exist.
 * @throws {Error} If something goes wrong.
 */

const getUTFGridDataURL = ({ layer, bbox }) => {
  const url = layerOps.getURL(layer);
  const subType = layerOps.getSubType(layer);

  let utfGridDataURL = '';

  if (LAYER_SUBTYPES.TMS === subType) {
    const tmsServer = url.substring(0, url.indexOf('geoserver') + 10);
    const layerName = url.substring(url.indexOf('tms') + 10, url.indexOf('@'));
    const field = layerName.split(':')[0];
    utfGridDataURL = `${tmsServer}${field}/wms?service=WMS&version=1.0.0&request=GetMap&layers=${layerName}&styles=&bbox=${bbox[1]},${bbox[0]},${bbox[3]},${bbox[2]}&width=461&height=768&srs=EPSG:4326&format=application%2Fjson%3Btype%3Dutfgrid`;
  }

  if (LAYER_SUBTYPES.WMS === subType) {
    const layerNames = layerOps.getWMSLayerNames(layer);
    const layerNamesArray = layerNames.split(',');
    if (layerNamesArray.length === 1) {
      const wmsServer = `${url}?`;
      let field = `${url.split('/')[4]}:`;
      if (field === WMS_DEFAULT_FIELD) field = '';
      utfGridDataURL = `${wmsServer}service=WMS&version=1.0.0&request=GetMap&layers=${field}${layerNames}&styles=&bbox=${bbox[1]},${bbox[0]},${bbox[3]},${bbox[2]}&width=461&height=768&srs=EPSG:4326&format=application%2Fjson%3Btype%3Dutfgrid`;
    }
  }

  return utfGridDataURL;
};

export default getUTFGridDataURL;
